window.addEventListener("load", function () {
  console.log("Custom JS running");
  const openingTimes = document.querySelectorAll(
    '[data-block-id="text_hKbm8B"] .metafield-single_line_text_field'
  );
  
  if (openingTimes) {
    openingTimes.forEach((openingTime) => {
      const text = openingTime.innerText;
  
      const parts = text.split(":");
  
      const firstPart = document.createElement("strong");
      firstPart.innerText = parts[0];
      firstPart.classList.add("opening-time-day");
      openingTime.innerHTML = "";
      openingTime.appendChild(firstPart);
  
      const secondPart = document.createElement("span");
      secondPart.innerText = parts[1];
      secondPart.classList.add("opening-time-times");
      openingTime.appendChild(secondPart);
    });
  }
});